<template>
  <v-combobox
      item-value="key"
      item-text="value"
      :value="current"
      :items="filterItems"
      :readonly="readonly"
      :error-messages="errorMessages"
      :label="label"
      :loading="isLoading"
      :search-input.sync="search"
      :clearable="!readonly"
      :prepend-icon="prependIcon"
      return-object
      eager
      :dense="dense"
      @change="change"
      @contextmenu.prevent>
    <template v-slot:prepend-inner>
      <v-icon
          v-if="required"
          small
          left
          :color="requiredColor">
        *
      </v-icon>
    </template>
  </v-combobox>
</template>

<script>
  import { DICTIONARY_TYPES } from '@/constants/business'
  import { mapActions, mapState } from 'vuex'
  import { DICTIONARIES } from '@/constants/store.js'

  export default {
    props: {
      value: {
        type: [String, Number],
        default: null
      },
      required: {
        type: Boolean,
        default: false
      },
      requiredColor: {
        type: String,
        default: 'requiredfield'
      },
      prependIcon: {
        type: String
      },
      errorMessages: Array,
      label: {
        type: String,
        default: ''
      },
      readonly: {
        type: Boolean,
        default: false
      },
      dense: {
        type: Boolean,
        default: false
      },
      dictionaryType: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        isLoading: false,
        search: ''
      }
    },
    computed: {
      ...mapState(DICTIONARIES.NAMESPACE, {
        dictionaries: state => (state || {})
      }),
      allItems () {
        const items = this.dictionaries[this.dictionaryType] || []
        return items.map(i => ({
          ...i,
          key: this.dictionaryType === DICTIONARY_TYPES.REGIONS ||
            this.dictionaryType === DICTIONARY_TYPES.COUNTRIES
            ? parseInt(i.key)
            : i.key,
          value: i.additional
            ? `${i.value} (${i.additional})`
            : i.value
        }))
      },
      current () {
        const vm = this
        return vm.allItems.find(u => u.key === vm.value)
      },
      filterItems () {
        let items = this.allItems
        if (this.search && (!this.current || this.search !== this.current.value)) {
          items = items.filter(p => p.value.includes(this.search))
        }
        if (this.current && this.current.key) {
          items = items.filter(p => this.current.key !== p.key)
        }
        return items
      }
    },
    created () {
      if (this.allItems.length) {
        return
      }
      this.getIdentityDictionaryItems()
    },
    methods: {
      ...mapActions(DICTIONARIES.NAMESPACE, {
        getIdentityDictionaryItemsAction: DICTIONARIES.ACTIONS.GET_IDENTITY_DICTIONARY_ITEMS
      }),
      getIdentityDictionaryItems: async function () {
        try {
          this.isLoading = true
          await this.getIdentityDictionaryItemsAction({
            dictionaryType: this.dictionaryType
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      change: function (item) {
        this.$emit('input', item ? item.key : null)
      }
    }
  }
</script>
